import React from 'react';

const RevenueIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.0026 12H2.66927C2.31565 12 1.97651 11.8595 1.72646 11.6095C1.47641 11.3594 1.33594 11.0203 1.33594 10.6667V5.33333C1.33594 4.97971 1.47641 4.64057 1.72646 4.39052C1.97651 4.14048 2.31565 4 2.66927 4H13.3359C13.6896 4 14.0287 4.14048 14.2787 4.39052C14.5288 4.64057 14.6693 4.97971 14.6693 5.33333V8.66667M12.0026 8H12.0093M12.6693 14.6667V10.6667M12.6693 10.6667L14.6693 12.6667M12.6693 10.6667L10.6693 12.6667M4.0026 8H4.00927M9.33594 8C9.33594 8.73638 8.73898 9.33333 8.0026 9.33333C7.26622 9.33333 6.66927 8.73638 6.66927 8C6.66927 7.26362 7.26622 6.66667 8.0026 6.66667C8.73898 6.66667 9.33594 7.26362 9.33594 8Z'
        stroke='black'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default RevenueIcon;
